import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './App.css';
import {Provider} from 'react-redux';
import {store} from './Components/Redux/Store';

ReactDOM.render(
  <Provider store={store}>
    <App className='App'/>
  </Provider>,
  document.getElementById('root')
);
